/**
 * Admin API — thin wrapper around the cookie-authenticated adminApi axios
 * instance. Every endpoint here mirrors an admin route on the backend.
 */
import { adminApi } from './api';

export async function adminLogin(password) {
  const { data } = await adminApi.post('/admin/login', { password });
  return data;
}

export async function adminLogout() {
  const { data } = await adminApi.post('/admin/logout');
  return data;
}

export async function adminMe() {
  const { data } = await adminApi.get('/admin/me');
  return data;
}

export async function adminList(resource) {
  const { data } = await adminApi.get(`/admin/${resource}`);
  return data;
}

export async function adminCreate(resource, body) {
  const { data } = await adminApi.post(`/admin/${resource}`, body);
  return data;
}

export async function adminUpdate(resource, id, body) {
  const { data } = await adminApi.put(`/admin/${resource}/${id}`, body);
  return data;
}

export async function adminUpsertSingleton(resource, body) {
  const { data } = await adminApi.put(`/admin/${resource}`, body);
  return data;
}

export async function adminDelete(resource, id) {
  const { data } = await adminApi.delete(`/admin/${resource}/${id}`);
  return data;
}

export async function adminReorder(resource, ids) {
  const { data } = await adminApi.post(`/admin/${resource}/reorder`, { ids });
  return data;
}

/** Upload an image to the CMS. Returns { id, url, size }. */
export async function adminUploadImage(file) {
  const form = new FormData();
  form.append('file', file);
  const { data } = await adminApi.post('/admin/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

/** List enquiries with optional filters (course, dateFrom, dateTo, q). */
export async function adminListEnquiries(params = {}) {
  const { data } = await adminApi.get('/admin/enquiries', { params });
  return data;
}
